<template>
  <div class="BaseLocationsDropdown">
    <div class="mdms">
      <nav class="main_nav">
        <!-- <p class="label"s>Location</p> -->
        <ul v-if="user.access_level != 'outlet'">
          <li class="first__li">
            <!-- <div class="mdms__input">
							<input style="height:40px" type="text" placeholder="select location" />
            			</div>-->
            <div class="display__selected">
              <simplebar class="display__selected--scroll">
                <span v-if="!selected.length" class="placeholder">{{
                  $route.name == "EventList"
                    ? "Select Location"
                    : placeholder.length
                    ? placeholder
                    : "All"
                }}</span>
                <span
                  v-for="(item, index) in selected"
                  :key="index"
                  class="mdms__selected"
                  @click="removeFromSelectedArray(item)"
                >
                  <span class="mdms__selected--val text-xxs">{{
                    item.name
                  }}</span>
                  <i class="el-icon-close pl-1 text-xxs" />
                </span>
              </simplebar>
            </div>

            <ul>
              <li v-for="(level1, index1) in newLocation" :key="index1">
                <div
                  class="displayVal"
                  :disabled="user.access_level != 'admin'"
                  @click="pushToSelectedArray($event, level1)"
                >
                  <span>{{ level1.name }}</span>
                  <i
                    v-if="selected[0] && selected[0].id == level1.id"
                    class="el-icon-check text-xs"
                  />
                </div>
                <ul
                  v-if="!level1.isSelected && level1.hasOwnProperty('regions')"
                >
                  <li
                    v-for="(level2, index2) in level1.regions.length > 0
                      ? level1.regions
                      : level1.outlets"
                    :key="index2"
                  >
                    <div
                      class="displayVal"
                      :disabled="
                        user.access_level == 'sub_region' ||
                        user.access_level == 'outlet'
                      "
                      @click="pushToSelectedArray($event, level2)"
                    >
                      <span>{{ level2.name }}</span>
                      <i
                        v-if="selected[0] && selected[0].id == level2.id"
                        class="el-icon-check text-xs"
                      />
                    </div>
                    <ul
                      v-if="
                        !level2.isSelected &&
                        level2.hasOwnProperty('subregions')
                      "
                    >
                      <li
                        v-for="(level3, index3) in level2.subregions.length > 0
                          ? level2.subregions
                          : level2.outlets"
                        :key="index3"
                      >
                        <div
                          class="displayVal"
                          :disabled="user.access_level == 'outlet'"
                          @click="pushToSelectedArray($event, level3)"
                        >
                          <span>{{ level3.name }}</span>
                          <i
                            v-if="selected[0] && selected[0].id == level3.id"
                            class="el-icon-check text-xs"
                          />
                        </div>
                        <ul
                          v-if="
                            !level3.isSelected &&
                            level3.hasOwnProperty('outlets') &&
                            $route.name != 'StoreType' &&
                            $route.name != 'SalesStoreType' && show_option
                          "
                          class="scrollable-list"
                        >
                          <!-- <simplebar class="dropdown__scroll"> -->
                          <li
                            v-for="(level4, index4) in level3.outlets"
                            :key="index4"
                          >
                            <div
                              class="displayVal"
                              @click="pushToSelectedArray($event, level4)"
                            >
                              <span>{{ level4.name }}</span>
                              <i
                                v-if="
                                  selected[0] && selected[0].id == level4.id
                                "
                                class="el-icon-check text-xs"
                              />
                            </div>
                          </li>
                          <!-- </simplebar> -->
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>

        <div v-else>
          <el-select
            v-model="selectStore"
            class="custom-input"
            style="width: 100%"
            disabled
            name="Select Store"
          >
            <el-option :value="selectStore" :label="selectStore">
              {{ selectStore }}
            </el-option>
          </el-select>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { EventBus } from "../../eventBus";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import { serverAddr } from "../../networkConfig";
import CommonService from "../../services/commonService";
import CommonUtils from "../../utils/common.utils";
export default {
  name: "BaseLocationsDropdown",
  components: {
    simplebar,
  },
  props: {
    selectedLocation: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      locations: [],
      selected: [],
      selectStore: "",
      newLocation: [],
      basics: "",
      user: {},
      show_option: true,
    };
  },
  computed: {
    // ...mapState("CommonStore", ["locations"])
  },
  created() {
   this.createdFunctionCall();
  },

  mounted() {
    EventBus.$on("refreshData", this.refreshDropDownData);

    // EventBus.$on("clearSelctedInputs", () =>{
    //   this.selected = [];
    // });

    this.email = localStorage.getItem('user_email');
		this.checkUserAuth();

    setTimeout(() =>{
      this.getLocationAsPerAccessLevel();
    }, 1000)
  },

  methods: {
    checkUserAuth(){
			// admin@wellnessforever.in
			if(this.email == 'tushar.shinde@wellnessforever.in' || this.email == 'gokuldas.gawade@wellnessforever.in' || this.email == 'safiahmad.khan@wellnessforever.in' || this.email == 'ratnesh.maurya@wellnessforever.in' || this.email == 'amar.soni@wellnessforever.in'){
				this.show_option = false
			}else{
				this.show_option = true
			}
		},
    getLocationAsPerAccessLevel(){
      let newLocation = [];
      serverAddr
        .get("/users/self/", {})
        .then((res) => {
          // console.log(JSON.parse(res.data));
          let user = JSON.parse(res.data);
          this.user = JSON.parse(res.data);
          if (user.access_level == "region") {
            var filteredArray = this.locations
              .filter((element) =>
                element.regions.some(
                  (regions) => regions.id === user.access_region[0]
                )
              )
              .map((element) => {
                let n = Object.assign({}, element, {
                  regions: element.regions.filter(
                    (regions) => regions.id === user.access_region[0]
                  ),
                });
                return n;
              });
            this.newLocation = filteredArray;
            // console.log("newLocation", filteredArray);
          } else if (user.access_level == "sub_region") {
            var op = this.locations.map((val) => {
              let regions = val.regions
                .filter(({ subregions }) =>
                  subregions.some(({ id }) => {
                    return id == user.access_subregion[0];
                  })
                )
                .map((subregions) => {
                  let n = Object.assign({}, subregions, {
                    subregions: subregions.subregions.filter(
                      (subregions) => subregions.id === user.access_subregion[0]
                    ),
                  });
                  return n;
                });

              val.regions = regions;
              return val;
            });
            this.newLocation = op;
            // console.log("newLocation", op);
          } else if (user.access_level == "admin") {
            this.newLocation = this.locations;
          } else {
            this.selectStore = user.access_outlet_name;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createdFunctionCall() {
      if (this.$route.name == "forecastCategory") {
      this.getLocations({
        type: [
          "store",
          "warehouse",
          "head_office",
          "distribution_centre",
          "regional_office",
          "vendor",
        ],
      });
    } else if (this.$route.name == "forecastCentralKitchen") {
      this.getLocations({ type: ["central_kitchen"] });
    } else {
      this.getLocations();
    }
    if (this.selectedLocation.length) {
      for (let index = 0; index < this.selectedLocation.length; index++) {
        // console.log(this.selectedLocation[index]);
        this.pushToSelectedArray(this.$event, this.selectedLocation[index]);
        setTimeout(() => {
          this.newLocation.forEach((l1) => {
            if (this.selectedLocation[index].id == l1.id) {
              l1.isSelected = true;
            } else {
              l1.regions.forEach((l2) => {
                if (this.selectedLocation[index].id == l2.id) {
                  l2.isSelected = true;
                } else {
                  l2.subregions.forEach((l3) => {
                    if (this.selectedLocation[index].id == l3.id) {
                      l3.isSelected = true;
                    } else {
                      l3.outlets.forEach((l4) => {
                        if (this.selectedLocation[index].id == l4.id) {
                          l4.isSelected = true;
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }, 1000);
      }
    }
    },
    refreshDropDownData() {
      console.log('refreshDropDownData');
      this.selected = [];
      this.basics = "";
      this.newLocation = [];
      this.createdFunctionCall();
      this.getLocationAsPerAccessLevel();
    },
    // ...mapActions("CommonStore", ["getLocations"]),
    pushToSelectedArray(event, selectedObj) {
      if (this.$route.name != "Category") {
        EventBus.$emit("breadCrumbs", []);
      }
      // display array is selected array.
      // push the selected obj to the display array to display the selected field,
      // and also remove the selected field from the display area.
      // and also remove the fields if basics field changes

      // console.log("selectedObj", selectedObj);
      this.basics = selectedObj.type; // set the basics so that other selected fields can be removed from display array
      selectedObj.isSelected = !selectedObj.isSelected; // toggle selected field
      if (selectedObj.isSelected) {
        this.selected = [selectedObj]; // push selected field to display array.
      } else {
        this.removeElement(selectedObj); // remove field from the display array
      }
      const duplicateloc_selected = this.selected.slice(); // duplicate the display array
      duplicateloc_selected.map((obj) => {
        // remove fields if basics field is changed
        if (obj.type != this.basics) {
          this.removeFromSelectedArray(obj, "FromPushToSelectedArray");
        }
      });
      for (let country = 0; country < this.newLocation.length; country++) {
        if (!this.newLocation[country].isSelected) {
          for (
            let region = 0;
            region < this.newLocation[country].regions.length;
            region++
          ) {
            if (!this.newLocation[country].regions[region].isSelected) {
              for (
                let subregion = 0;
                subregion <
                this.newLocation[country].regions[region].subregions.length;
                subregion++
              ) {
                if (
                  !this.newLocation[country].regions[region].subregions[
                    subregion
                  ].isSelected
                ) {
                  for (
                    let store = 0;
                    store <
                    this.newLocation[country].regions[region].subregions[
                      subregion
                    ].outlets.length;
                    store++
                  ) {
                    if (
                      !this.newLocation[country].regions[region].subregions[
                        subregion
                      ].outlets[store].isSelected
                    ) {
                    } else {
                      if (
                        this.newLocation[country].regions[region].subregions[
                          subregion
                        ].outlets[store].id != selectedObj.id
                      ) {
                        this.newLocation[country].regions[region].subregions[
                          subregion
                        ].outlets[store].isSelected = false;
                      }
                    }
                  }
                } else {
                  if (
                    this.newLocation[country].regions[region].subregions[
                      subregion
                    ].id != selectedObj.id
                  ) {
                    this.newLocation[country].regions[region].subregions[
                      subregion
                    ].isSelected = false;
                  }
                }
              }
            } else {
              if (
                this.newLocation[country].regions[region].id != selectedObj.id
              ) {
                this.newLocation[country].regions[region].isSelected = false;
              }
            }
          }
        } else {
          if (this.newLocation[country].id != selectedObj.id) {
            this.newLocation[country].isSelected = false;
          }
        }
      }
      this.$emit("update", {
        basics: this.basics,
        selected: this.selected,
        list: this.newLocation,
      });
    },
    removeFromSelectedArray(removedObj, FromPushToSelectedArray) {
      if (this.$route.name != "Category") {
        EventBus.$emit("breadCrumbs", []);
      }
      // reomove the selected field from dipslay array.
      removedObj.isSelected = false; // make the selected field to false
      this.removeElement(removedObj, FromPushToSelectedArray); // actual removal of field
    },
    removeElement(elementToRemove, FromPushToSelectedArray) {
      // check each element in the array and remove the field.
      this.selected.forEach((obj, i, arr) => {
        if (obj.id === elementToRemove.id) {
          arr.splice(arr.indexOf(obj), 1);
        } // remove the selected value from the screen
      });
      if (!FromPushToSelectedArray) {
        this.$emit("update", { basics: this.basics, selected: this.selected });
      }
    },
    getLocations(args) {
      CommonService.getLocations(args)
        .then((response) => {
          var locations = CommonUtils.insertIsSelectedKey(
            JSON.parse(response.data).results
          );
          locations.forEach((item, index) => {
            this.$set(this.locations, index, item);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  // beforeDestroy() {
  //   EventBus.$off("clearSelctedInputs");
  // },
};
</script>

<style scoped lang="scss">
@import "../baseLocationsDD/BaseLocationsDD.scss";
@import "../../assets/css/variable.scss";
.AppForecast {
  background-color: #fff;
}

.AppForecast .Schedule-btn {
  margin: 0 10px 12px;
  padding: 8px 12px 6px !important;
  background-color: $orange-bg-button-color;
  border: 1px solid $orange-bg-button-color;
  @extend .amp-btn;
}

.AppForecast .search-container input:focus {
  outline: none;
}

.AppForecast .second-sec {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 15px 0;
}
</style>
<style>
.AppForecast .el-input__inner {
  border-color: #c8c8c8;
  border-radius: 4px;
}
.AppForecast .el-input--suffix .el-input__inner {
  padding-right: 58px;
}
div[disabled="disabled"] {
  pointer-events: none !important;
  opacity: 0.7;
}
.scrollable-list{
  z-index: 9999;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
